import { FMSCapabilityKey, FMSCapabilityState, FMSObjectType, FMSType, FMS_CAPABILITY_MATRIX } from "@swivl-mono/types";

/**
 * The runtime gate for the FMS Capability Matrix. Every sync path must call this
 * before making an FMS call for a given object type + capability.
 *
 * Reads ONLY the `implemented` state — `available`, `none`, and `tbd` are all
 * informational and never trigger behavior. Callers derive `fmsId` from the location's
 * config (e.g. ServerLocationVarsHelper.getEffectiveFMSTypeForAllLocations); the FMS is
 * never hardcoded.
 *
 * Returns `false` for any undeclared FMS / object type / capability — the safe default
 * is to NOT call an FMS for something the matrix hasn't declared implemented.
 */
export function hasCapability(fmsId: FMSType, objectType: FMSObjectType, capability: FMSCapabilityKey): boolean {
  return FMS_CAPABILITY_MATRIX[fmsId]?.[objectType]?.[capability]?.state === FMSCapabilityState.Implemented;
}
